import React from "react";
import moment from "moment";
import { css } from "aphrodite";
import styles from "./style";

const DayLine = (props) => {
  let dt = moment.unix(props.calStartDate.valueOf() / 1000).startOf("day");
  let tblHeader = [];
  let loopIndex = 0;
  while (dt.isSameOrBefore(props.calEndDate)) {
    let d = dt;
    let timestamp = dt.valueOf() / 1000;
    tblHeader.push(
        <th
          style={{
            backgroundColor: "#4E4E4E",
            textAlign: "center",
          }}
          key={dt.valueOf()}
        >
          <span
            className={css([
              props.selectedDate !== 0
                ? moment.unix(props.selectedDate).isSame(moment.unix(d / 1000))
                  ? styles.selectedDate
                  : ""
                : "",
            ])}
            style={{ cursor: "pointer", color: "#FFF" }}
            onClick={(event) => props.selectDate(event, timestamp)}
          >
            {dt.format("DD")}
          </span>
        </th>
    );
    dt = dt.add(1, "days");
    loopIndex++;
    /*if (loopIndex > 29) break;*/
  }

  if (loopIndex < 30) {
    for (let x = loopIndex; x < 30; x++) {
      tblHeader.push(
          <th
            style={{
              backgroundColor: "#4E4E4E",
            }}
            key={x}
          >
            <span> </span>
          </th>
      );
    }
  }

  return (
      <thead
        style={{
            backgroundColor: "#4E4E4E",
            boxShadow: "inset 0px 6px 15px -8px rgba(0,0,0,0.45)",
          }}
      >
        <tr
        style={{
          backgroundColor: "#4E4E4E",
        }}
      >
        <th
        style={{
          backgroundColor: "#4E4E4E",
          //paddingLeft: "2em"
        }}
      >
        <span
          className={css([
            styles.monthLeft,
            props.showPrevious ? styles.show : styles.hide,
          ])}
          onClick={props.preiousMonth}
        >
          <img
            src="/images/diary/calendar_month_left_icon.png"
            alt="Previous Month"
            className={css(styles.iconOpacity)}
          />
        </span>
        </th>
      {tblHeader}
      <th
        style={{
          backgroundColor: "#4E4E4E",
        }}
      >
        <span
          className={css([
            styles.monthRight,
            props.showNext ? styles.show : styles.hide,
          ])}
          onClick={props.nextMonth}
        >
          <img
            src="/images/diary/calendar_month_right_icon.png"
            alt="Next Month"
            className={css(styles.iconOpacity)}
          />
        </span>
        </th>
        </tr>
      </thead>
  );
};

export default DayLine;
